import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observable } from 'mobx'
import { observer, inject } from 'mobx-react'

import ReleaseInfo from './ReleaseInfo'
import ReleaseNav from './ReleaseNav'
import ReleaseHeader from './ReleaseHeader'
import ReleaseControls from './ReleaseControls'
import ReleaseForms from './ReleaseForms'
import ReleaseStepper from './ReleaseStepper'

import MuseumDetails from '../../frontend/museum/components/Details'
import GuidedTourDetails from '../../frontend/guided-tour/components/Details'
import ProgramDetails from '../../frontend/program/components/Details'

import getSecctionsForDirtyFields from '../../shared/utils/getSecctionsForDirtyFields'
import Preview from '../../shared/components/Preview'

const releaseConfirmationMessage = (draft) => {
  const types = {
    'guided-tour': 'die Führung',
    program: 'das Programm',
    museum: 'das Museum',
  }
  return `Möchten Sie ${types[draft.type]} "${
    draft.name || draft.title
  }" wirklich freigeben?`
}

const deleteConfirmationMessage = (draft) => {
  const types = {
    'guided-tour': 'die Führung',
    program: 'das Programm',
    museum: 'das Museum',
  }
  return `Möchten Sie ${types[draft.type]} "${
    draft.name || draft.title
  }" wirklich endgöltig löschen?`
}

const REASON_PLACEHOLDER = '<Ablehnungsgrund>'

const getDefautMessage = (user, auth) => {
  return `Sehr geehrte${user.address === 'Frau' ? '' : 'r'} ${user.address} ${user.surname},

${REASON_PLACEHOLDER}

Viele Grüße
${auth.user.firstname} ${auth.user.surname}`
}

@inject('auth') @observer
export default class VersionPage extends Component {

  /* eslint-disable react/sort-comp */
  @observable dirtySections = []

  @observable openedSections = []

  @observable showPreview = false
  /* eslint-enable react/sort-comp */

  static propTypes = {
    auth: PropTypes.object,
    draft: PropTypes.object,
    isBusy: PropTypes.bool,
    onClose: PropTypes.func,
    onDelete: PropTypes.func,
    onReject: PropTypes.func,
    onSave: PropTypes.func,
    version: PropTypes.object,
  }

  static typeSteps = {
    museum: [
      { key: 'address', title: '1. Anschrift' },
      { key: 'information', title: '2. Informationen' },
      { key: 'visit', title: '3. Besuch' },
      { key: 'equipment', title: '4. Ausstattung' },
      { key: 'media', title: '5. Medien' }
    ],
    program: [
      { key: 'general', title: '1. Allgemein' },
      { key: 'reference', title: '2. Bezug' },
      { key: 'booking', title: '3. Buchung & Kosten' },
      { key: 'material', title: '4. Materialien' },
      { key: 'media', title: '5. Medien' }
    ],
    guidedTour: [
      { key: 'general', title: '1. Allgemein' },
      { key: 'reference', title: '2. Bezug' },
      { key: 'booking', title: '3. Buchung & Kosten' },
      { key: 'media', title: '4. Medien' }
    ]
  }

  constructor(props) {
    super(props)

    const sections = VersionPage.typeSteps[props.draft.type].map((step) => step.key)
    this.origDraftData = props.draft.asJSON

    this.dirtySections = props.draft.dirty === true
      ? sections
      : getSecctionsForDirtyFields(
        props.draft.type,
        props.draft.dirty,
        sections
      )

    const section = this.dirtySections.length
      ? this.dirtySections[0]
      : sections[0]

    // first step is opend on load...
    this.openedSections = [section]
    // so remove it from the list of opend sections
    this.dirtySections.splice(this.dirtySections.indexOf(section), 1)

    this.state = {
      section,
      isRejecting: false,
      rejectionMessage: ''
    }
  }

  @autobind
  handleChange({ target }) {

    const { draft, draft: { type } } = this.props
    const { value } = target
    let { name } = target
    let formData = { [name]: value }

    if (name.indexOf('_message') === 0) {
      name = name.replace('_message.', `${type}-`)
      formData = {
        _message: {
          [name]: value
        }
      }
    }
    else if (name.indexOf('.') !== -1) {
      const parts = name.split('.')
      name = parts.pop()
      const obj = {}
      const parent = parts.reduce((memo, part) => {
        memo[part] = {}
        return memo[part]
      }, obj)
      parent[name] = value
      formData = obj
    }

    // if (name.indexOf('.') !== -1) {
    //   const parts = name.split('.')
    //   name = parts.pop()
    //   const obj = {}
    //   const parent = parts.reduce((memo, part) => {
    //     memo[part] = {}
    //     return memo[part]
    //   }, obj)
    //   parent[name] = value
    //   formData = obj
    // }

    draft.set(formData)

  }

  @autobind
  handleSave(e) {
    e.preventDefault()

    if (this.props.onSave) {
      // eslint-disable-next-line no-alert
      if (window.confirm(releaseConfirmationMessage(this.props.draft))) {
        this.props.onSave({
          target: this.props.draft
        })
      }
    }
  }

  @autobind
  handleTogglePreview(e) {
    e.preventDefault()

    this.showPreview = !this.showPreview
  }

  @autobind
  handleDelete(e) {
    e.preventDefault()

    if (this.props.onDelete) {
      // eslint-disable-next-line no-alert
      if (window.confirm(deleteConfirmationMessage(this.props.draft))) {
        this.props.onDelete({
          target: this.props.draft
        })
      }
    }
  }

  @autobind
  handleReject() {

    const { isRejecting, rejectionMessage } = this.state

    const user = this.props.draft.type === 'museum'
      ? this.props.draft.user
      : this.props.draft.museum.user

    const newState = {
      isRejecting: !isRejecting,
      rejectionMessage: this.state.rejectionMessage || getDefautMessage(user, this.props.auth)
    }

    // this is when actually hitting the send button
    if (isRejecting) {
      if (this.props.onReject) {
        this.props.onReject({
          target: this.props.draft,
          message: rejectionMessage
        })
      }
      newState.rejectionMessage = null
    }

    this.setState(newState)
  }

  @autobind
  handleAbort() {
    if (!this.state.isRejecting) {
      this.close()
    }
    else {
      this.setState({ isRejecting: false })
    }
  }

  @autobind
  handleSectionChange({ target: { value } }) {

    if (this.openedSections.indexOf(value) === -1) {
      this.openedSections.push(value)
    }

    const dirtySectionIndex = this.dirtySections.indexOf(value)
    if (dirtySectionIndex !== -1) {
      this.dirtySections.splice(dirtySectionIndex, 1)
    }

    this.setState({ section: value })
  }

  @autobind
  handleRejectionMessageChange({ target }) {
    this.setState({
      rejectionMessage: target.value
    })
  }

  close() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render() {

    const {
      draft,
      version,
      isBusy
    } = this.props

    const {
      section,
      rejectionMessage,
      isRejecting
    } = this.state

    const {
      type,
      isReleaseable,
      allFieldsRejected,
      _message
    } = draft

    const isRejectingField = !!Object.keys(_message || [])
      .filter((key) => !!_message[key]).length

    const user = type === 'museum'
      ? draft.user
      : draft.museum.user

    const steps = VersionPage.typeSteps[type]
    const navProps = {
      type,
      section,
      onChange: this.handleSectionChange,
      steps: steps.map((step) => ({
        ...step,
        dirty: this.dirtySections.indexOf(step.key) !== -1
      }))
    }

    let PreviewComponent = null
    let previewProps = {
      params: { id: draft ? draft.id || '-1' : '-1' },
      router: {},
    }
    switch (type) {
      case 'museum':
        PreviewComponent = MuseumDetails
        previewProps = {
          ...previewProps,
          guidedTour: {},
          program: {},
          museum: draft || {}
        }
        break
      case 'guidedTour':
        PreviewComponent = GuidedTourDetails
        previewProps = {
          ...previewProps,
          guidedTour: draft || {}
        }
        break
      case 'program':
        PreviewComponent = ProgramDetails
        previewProps = {
          ...previewProps,
          program: draft || {}
        }
        break
      default:
    }

    return (
      <div className="vertical release-layout">

        <Preview
          showPreview={this.showPreview}
          onTogglePreview={this.handleTogglePreview}
          previewComponent={PreviewComponent}
          previewProps={previewProps}
        />

        <div className="vertical">

          <ReleaseInfo user={user}
            onTogglePreview={this.handleTogglePreview}
          />

          <ReleaseNav {...navProps} />

          <ReleaseHeader />

          <ReleaseForms
            draft={draft}
            section={this.state.section}
            steps={this.state.steps}
            type={type}
            version={version}
            onChange={this.handleChange}
            onSectionChange={this.handleSectionChange}
            onSubmit={this.handleSave}
          />

          <ReleaseStepper {...navProps} />

        </div>

        <ReleaseControls
          allFieldsRejected={allFieldsRejected}
          isBusy={isBusy}
          isRejecting={isRejecting}
          isRejectingField={isRejectingField}
          isReleaseable={isReleaseable}
          onAbort={this.handleAbort}
          onDelete={this.handleDelete}
          onSave={this.handleSave}
          onReject={this.handleReject}
          onRejectionMessageChange={this.handleRejectionMessageChange}
          rejectionMessage={rejectionMessage}
          reasonPlaceholder={REASON_PLACEHOLDER}
          allDirtyFieldsResolved={!this.dirtySections.length}
          shouldDelete={!!draft.deletedAt}
        />

      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/release/components/VersionPage.js